/**
 * @fileoverview Deliverable drawer of the student tracker: the My tasks drawer (Mantine shell, auto-submit on
 * upload / first link, edit mode once delivered) fed with the student task resolved from the activity id.
 * While the task id is being resolved the drawer shows its own skeleton (empty identifier = loading).
 */

import { Center, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { StudentTaskDrawerShell } from 'pages/StudentTasks/components'
import { StudentDeliverableDrawer } from 'pages/StudentTasks/deliverableDrawer'
import { useStudentTaskId } from './useStudentTaskId'

const ERROR_FALLBACK_HEIGHT = 160

interface StudentTrackerDeliverableDrawerProps {
  opened: boolean
  activityId: string
  onClose: () => void
  onSubmitted?: () => void
}

export function StudentTrackerDeliverableDrawer({
  opened,
  activityId,
  onClose,
  onSubmitted,
}: StudentTrackerDeliverableDrawerProps) {
  const { t } = useTranslation()
  const { studentTaskId, failed } = useStudentTaskId(activityId, opened)

  if (failed) {
    return (
      <StudentTaskDrawerShell
        opened={opened}
        title={t('student_tasks.deliverable_drawer.submit_title')}
        onClose={onClose}
      >
        <Center style={{ height: ERROR_FALLBACK_HEIGHT }}>
          <Text color='dimmed' size='sm'>
            {t('student_tasks.deliverable_drawer.error_loading')}
          </Text>
        </Center>
      </StudentTaskDrawerShell>
    )
  }

  return (
    <StudentDeliverableDrawer
      opened={opened}
      identifierId={studentTaskId}
      onClose={onClose}
      onSubmitted={onSubmitted}
    />
  )
}
